/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_c_garden_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is GANDER an anagram of?`)
};

const es_wu_c_garden_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿De qué palabra es GANDER un anagrama?`)
};

const de_wu_c_garden_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wofür ist GANDER ein Anagramm?`)
};

const nl_wu_c_garden_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarvan is GANDER een anagram?`)
};

const fr_wu_c_garden_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GANDER est l'anagramme de quel mot ?`)
};

const it_wu_c_garden_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di quale parola GANDER è un anagramma?`)
};

const pt_br2_wu_c_garden_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GANDER é um anagrama de quê?`)
};

const pt_wu_c_garden_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GANDER é anagrama de quê?`)
};

const ja_wu_c_garden_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GANDERは何のアナグラムですか？`)
};

const zh_wu_c_garden_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GANDER 是哪个单词的易位构词？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_c_garden_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_c_garden_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_c_garden_faq2_q", locale)
	if (locale === "en") return en_wu_c_garden_faq2_q(inputs)
	if (locale === "es") return es_wu_c_garden_faq2_q(inputs)
	if (locale === "de") return de_wu_c_garden_faq2_q(inputs)
	if (locale === "nl") return nl_wu_c_garden_faq2_q(inputs)
	if (locale === "fr") return fr_wu_c_garden_faq2_q(inputs)
	if (locale === "it") return it_wu_c_garden_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_wu_c_garden_faq2_q(inputs)
	if (locale === "pt") return pt_wu_c_garden_faq2_q(inputs)
	if (locale === "ja") return ja_wu_c_garden_faq2_q(inputs)
	return zh_wu_c_garden_faq2_q(inputs)
};